/* IronWest Phase 5 enquiry context + dataLayer event hooks.
   This file does NOT load Google Analytics, GTM, pixels, or send network requests.
   Event consumers must be configured separately with appropriate consent controls. */
(function () {
  'use strict';
  const prefix = 'iw5:';
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const isContact = window.location.pathname.replace(/\/$/, '') === '/pages/contact';
  const allowedUtm = ['utm_source', 'utm_medium', 'utm_campaign'];
  const clean = (value, max) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, max || 130);
  const cleanTag = (value) => clean(value, 100).replace(/[^a-zA-Z0-9_.-]/g, '');
  const store = {
    get(key) { try { return sessionStorage.getItem(prefix + key) || ''; } catch (e) { return ''; } },
    set(key, value) { try { sessionStorage.setItem(prefix + key, value); } catch (e) {} },
    remove(key) { try { sessionStorage.removeItem(prefix + key); } catch (e) {} }
  };
  const pathname = clean(window.location.pathname, 200);
  const safeEvent = (event, props) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: event,
      iw5_source_path: pathname,
      iw5_site: 'ironwest'
    }, props || {}));
  };

  for (const utm of allowedUtm) {
    const value = cleanTag(params.get(utm));
    if (value && !store.get(utm)) store.set(utm, value);
  }

  const getUtm = (key) => cleanTag(params.get(key)) || cleanTag(store.get(key));
  const sameSitePath = (referrer) => {
    try {
      if (!referrer) return '';
      const r = new URL(referrer);
      if (r.hostname === window.location.hostname) return clean(r.pathname, 200);
    } catch (e) {}
    return '';
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    const anchor = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
    if (!anchor) return;
    let destination;
    try { destination = new URL(anchor.href, window.location.href); } catch (e) { return; }
    const sameSite = destination.origin === url.origin;
    const hrefPath = destination.pathname.replace(/\/$/, '');
    if (sameSite && hrefPath === '/pages/contact') {
      if (!isContact) store.set('source_page', pathname);
      const scope = clean(anchor.getAttribute('data-iw5-cta') || (pathname.startsWith('/products/') ? 'product_page' : pathname.startsWith('/pages/') ? 'information_page' : 'site_navigation'), 45);
      safeEvent('iw5_enquiry_click', {
        iw5_cta_location: scope,
        iw5_destination: '/pages/contact',
        iw5_product_context: Boolean(destination.searchParams.get('product'))
      });
      return;
    }
    if (destination.protocol === 'tel:') {
      safeEvent('iw5_phone_click', { iw5_cta_location: clean(anchor.getAttribute('data-iw5-cta') || 'site', 45) });
    } else if (destination.protocol === 'mailto:') {
      safeEvent('iw5_email_click', { iw5_cta_location: clean(anchor.getAttribute('data-iw5-cta') || 'site', 45) });
    } else if ((sameSite || destination.hostname === 'cdn.shopify.com' || destination.hostname === 'cdn.shopifycdn.net') && /\.pdf$/i.test(destination.pathname)) {
      safeEvent('iw5_spec_download', { iw5_file: clean(destination.pathname.split('/').pop(), 110) });
    }
  }, { passive: true });

  const onReady = () => {
    const page = document.querySelector('[data-iw5-contact]');
    if (!page || !isContact) return;
    const context = clean(params.get('product'), 180);
    const equipment = page.querySelector('[data-iw5-equipment]');
    if (equipment && context && !equipment.value) equipment.value = context;

    const sourcePath = clean(store.get('source_page') || sameSitePath(document.referrer) || '/pages/contact', 200);
    const contextField = page.querySelector('[data-iw5-context]');
    const sourceField = page.querySelector('[data-iw5-source-page]');
    if (contextField) contextField.value = context;
    if (sourceField) sourceField.value = sourcePath;
    for (const utm of allowedUtm) {
      const input = page.querySelector('[data-iw5-' + utm.replace('utm_', 'utm-').replace('_', '-') + ']');
      if (input) input.value = getUtm(utm);
    }

    const topic = page.querySelector('#iw5-enquiry-type');
    if (topic && context) {
      const label = context.toLowerCase();
      if (label.includes('light') || label.includes('tower')) topic.value = 'Lighting Tower';
      else if (label.includes('generator') || /\b(kva|kw)\b/i.test(label)) topic.value = 'Diesel Generator';
      else if (label.includes('battery')) topic.value = 'Battery Energy Storage';
      else if (label.includes('hybrid') || label.includes('custom') || label.includes('mining power')) topic.value = 'Hybrid / Custom Power';
    }

    const form = page.querySelector('form.iw5-contact__form');
    if (form) form.addEventListener('submit', () => {
      const submissionId = String(Date.now()) + ':' + Math.random().toString(36).slice(2);
      store.set('pending_submission', submissionId);
      safeEvent('iw5_enquiry_attempt', { iw5_form: 'project_enquiry', iw5_page_source: sourcePath });
    });

    // Only a Shopify server-rendered success state triggers a lead event.
    // A click or submit attempt is never treated as an enquiry conversion.
    const confirmation = page.querySelector('[data-iw5-success]');
    if (confirmation) {
      const pendingId = store.get('pending_submission');
      const dedupeKey = pendingId || 'direct-success:' + window.location.pathname;
      if (dedupeKey !== store.get('last_success')) {
        safeEvent('iw5_enquiry_success', {
          iw5_form: 'shopify_contact',
          iw5_page_source: sourcePath,
          iw5_utm_source: getUtm('utm_source'),
          iw5_utm_medium: getUtm('utm_medium'),
          iw5_utm_campaign: getUtm('utm_campaign')
        });
        store.set('last_success', dedupeKey);
      }
      store.remove('pending_submission');
      confirmation.focus({ preventScroll: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, { once: true });
  else onReady();
})();